/**
 * 模块说明：业务仓管理
 */
import { Service } from '@/tools'
export class PackageControlService<T extends TSupplier.PackageControl> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSupplier.PackageControl}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：查询发货包件数控制列表
   * /api/supplier/packageControl/v1/selectSupplierPackageControl
   */
  selectSupplierPackageControl = <K extends T['ApiSelectSupplierPackageControl']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectSupplierPackageControl', data)

  /**
   * 功能：发货包件数控制修改
   * /api/supplier/packageControl/v1/updatePackageControl
   */
  updatePackageControl = <K extends T['ApiUpdatePackageControl']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUpdatePackageControl', data, '操作成功')

  /**
   * 功能：修改状态
   * /api/supplier/packageControl/v1/updateStatus
   */
  updateStatus = <K extends T['ApiUpdateStatus']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateStatus', data, '操作成功')
}
